﻿import Transition from './pageTransition.js';
import Scroll from './scroll.js';


// Function to update the active state of navigation links
function updateActiveState(activeLink) {
    // Remove 'active' class from all nav-links
    document.querySelectorAll('.nav-link').forEach(link => link.classList.remove('active'));

    // Add 'active' class to the clicked or active link
    activeLink.classList.add('active');
}


function loadContentWithTransition(url, contentWrapper, transition, pushUrl = false) {
	if (!url) {
		console.error('Invalid URL');
		return;
	}

	Transition.show(transition, contentWrapper);
	
    const delay = isFullscreenMenuActive() ? 0 : 300;

    $.ajax({
        url: url,
        type: 'GET',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        success: function (data) {
            setTimeout(() => {
                contentWrapper.html(data);
				if (pushUrl) window.history.pushState(null, '', url);
                
				Scroll.top(Scroll.Behavior.INSTANT);

                initializeScrollex();
                $(window).trigger('scroll');
            }, delay);
        },
        error: function () {
            alert('Failed to load content. Please try again.');
        },
		complete: function () {
            setTimeout(() => {
                Transition.hide(transition, contentWrapper);
            }, delay);
        }
    });
}


function handleSamePageNavigation(url) {
    if (window.location.pathname === url) {
        return true; 
    }
    return false;
}


//Ajax page navigation for Single-Page-Application
function initializeAjaxNavigation() {
	const contentWrapper = $('#content-wrapper');
    const transition = document.getElementById("page-transition");

    // Handle link clicks with AJAX
    $('body').on('click', 'a[data-ajax="true"]', function (e) {
        e.preventDefault(); // Prevent default link behavior
        e.stopPropagation();
        e.stopImmediatePropagation();
        const url = $(this).attr('href'); // Get the URL from the link


		if (handleSamePageNavigation(url)) {
			Scroll.top(Scroll.Behavior.SMOOTH);
		}
		else {
			updateActiveState(this);
			loadContentWithTransition(url, contentWrapper, transition, true);
		}

		
		toggleFullscreenMenu(false);
    });

    // Handle browser back/forward navigation
    window.onpopstate = function () {
        const url = window.location.href;
		if (window.location.hash) {
			return;
		}
        loadContentWithTransition(url, contentWrapper, transition);
    };
}


// Scroll listener for nav-pill
function initializeNavbarScrollBehavior() {
	const navbar = document.querySelector('.navbar');

    // Scroll event listener for adding/removing 'scrolled' class
    window.addEventListener('scroll', function () {
        // Force reflow to help with transition
        void navbar.offsetWidth;
        if (window.scrollY > 0) {
            navbar.classList.add('scrolled');
        } else {
            navbar.classList.remove('scrolled');
        }
    });

    // Function to update scroll padding top
    function updateScrollPaddingTop() {
        const stickyNav = document.querySelector('.navbar');
        if (stickyNav) {
            const navHeight = stickyNav.offsetHeight - 2;
            document.documentElement.style.setProperty('--scroll-padding-top', `${navHeight}px`);
        }
    }
    // Update on load
    updateScrollPaddingTop();

    // Add a delay to ensure the transition applies correctly
    setTimeout(() => {
        if (window.scrollY === 0) {
            navbar.classList.remove('scrolled');
        }
    }, 1050); // Adjust the delay as needed

    // Update on resize
    window.addEventListener('resize', updateScrollPaddingTop);
}

function initializeHamburgerMenuToggle() {
    const burgerInput = document.getElementById("burger1");

    if (burgerInput) {
        burgerInput.addEventListener('change', () => {
            toggleFullscreenMenu(burgerInput.checked);
        });
    }
}

function toggleFullscreenMenu(isChecked) {
    const fullscreenMenu = document.querySelector(".fullscreen-menu");
    const burgerInput = document.getElementById("burger1");

    if (burgerInput) {
        burgerInput.checked = isChecked;
    }

    fullscreenMenu?.classList.toggle("active", isChecked);

    // Prevent background scroll when menu is active
    if (isChecked) {
        document.body.classList.add("no-scroll");
    } else {
        document.body.classList.remove("no-scroll");
        
        // Reset scroll direction observer state when closing menu
        if (window.resetScrollDirectionObserver) {
            window.resetScrollDirectionObserver();
        }
    }
}

function isFullscreenMenuActive() {
    const fullscreenMenu = document.querySelector(".fullscreen-menu");
    return fullscreenMenu?.classList.contains("active") || false;
}


function initializeFullscreenMenuSwipeClose() {
    const fullscreenMenu = document.querySelector('.fullscreen-menu');
    if (!fullscreenMenu) return;

    let touchStartX = null;

    fullscreenMenu.addEventListener('touchstart', function(e) {
        if (e.touches.length === 1) {
            touchStartX = e.touches[0].clientX;
        }
    });

    fullscreenMenu.addEventListener('touchend', function(e) {
        if (touchStartX === null) return;
        const touchEndX = e.changedTouches[0].clientX;
        const deltaX = touchEndX - touchStartX;

        if (Math.abs(deltaX) > 50) { // Swipe threshold
            toggleFullscreenMenu(false);
        }
        touchStartX = null;
    });
}


function initializeCallToActionNavObserver() {
    const callToAction = document.getElementById('parallax-divider');
    const navbar = document.querySelector('.navbar');

    if (!callToAction || !navbar) return;

    function checkCallToActionPosition() {
        const callToActionTop = callToAction.getBoundingClientRect().top;
        const viewportTop = 0; // Top of the viewport

        if (callToActionTop <= viewportTop) {
            // Add "offscreen" class when the user scrolls past the parallax-divider
            navbar.classList.add('offscreen');
        } else {
            // Remove "offscreen" class when the user scrolls back up
            navbar.classList.remove('offscreen');
        }
    }

    // Attach the scroll event listener
    window.addEventListener('scroll', checkCallToActionPosition);

    // Run the check on page load
    checkCallToActionPosition();
}


function initializeScrollDirectionObserver() {
    const navbar = document.querySelector('.navbar');
    let lastScrollPosition = window.scrollY;
    let hideBuffer = 0;
    let showBuffer = 0;
    const HIDE_THRESHOLD = 60; // px to scroll down before hiding
    const SHOW_THRESHOLD = 40; // px to scroll up before showing
    const THROTTLE_DELAY = 50; // ms
    let throttleTimeout = null;
    let isNavbarPinned = false;

    if (!navbar) return;

    // Expose reset function globally so toggleFullscreenMenu can call it
    window.resetScrollDirectionObserver = function() {
        lastScrollPosition = window.scrollY;
        hideBuffer = 0;
        showBuffer = 0;
        isNavbarPinned = false;
        
        // Remove offscreen class to ensure navbar is visible after menu closes
        navbar.classList.remove('offscreen');
    };

    // Pin navbar on hover (navbar and dropdowns)
    function setPinState(pin) {
        isNavbarPinned = pin;
        if (pin) {
            navbar.classList.remove('offscreen');
        }
    }

    navbar.addEventListener('mouseenter', () => setPinState(true));
    navbar.addEventListener('mouseleave', () => setPinState(false));
    navbar.querySelectorAll('.dropdown-menu').forEach(menu => {
        menu.addEventListener('mouseenter', () => setPinState(true));
        menu.addEventListener('mouseleave', () => setPinState(false));
    });

    function checkScrollDirection() {
        if (isNavbarPinned) return; // Don't hide if pinned
        const currentScrollPosition = window.scrollY;
        const delta = currentScrollPosition - lastScrollPosition;

        if (delta > 0) {
            // Scrolling down
            hideBuffer += delta;
            showBuffer = 0;
            if (hideBuffer > HIDE_THRESHOLD) {
                navbar.classList.add('offscreen');
                hideBuffer = 0; // reset after hiding
            }
        } else if (delta < 0) {
            // Scrolling up
            showBuffer -= delta; // delta is negative
            hideBuffer = 0;
            if (showBuffer > SHOW_THRESHOLD) {
                navbar.classList.remove('offscreen');
                showBuffer = 0; // reset after showing
            }
        }
        lastScrollPosition = currentScrollPosition;
    }

    function throttledScrollHandler() {
        if (throttleTimeout) return;
        throttleTimeout = setTimeout(() => {
            checkScrollDirection();
            throttleTimeout = null;
        }, THROTTLE_DELAY);
    }

    window.addEventListener('scroll', throttledScrollHandler);
}



$(document).ready(function () {
    initializeAjaxNavigation();
	initializeNavbarScrollBehavior();
	//initializeNavPillWrapCheck();
	initializeHamburgerMenuToggle();
	//initializeCallToActionNavObserver();
	initializeScrollDirectionObserver();
    initializeFullscreenMenuSwipeClose();

    // Close fullscreen menu when a nav-item is clicked
    $(document).on('click', '.fullscreen-menu .nav-link', function () {
        toggleFullscreenMenu(false);
    });
});



if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
}